




export default {
    name: "BodyPortalTarget",
};
